//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'

//styles
import './FormOptions.less'

class FormOptions extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
        ]),
        onSelect: PropTypes.func,
        activeKey: PropTypes.string,
    };

    static defaultProps = {
        onSelect: () => null
    };

    render() {
        const {activeKey} = this.props;
        let {children: Options} = this.props;

        Options = !_.isArray(Options) ? [Options] : Options;
        Options = Options.map((option, index) => {
            return React.cloneElement(option, {
                onClick: this.props.onSelect,
                key: index,
                activeKey
            });
        });

        return (
            <div className="form-options">{Options}</div>
        )
    }
}

export default FormOptions



/** WEBPACK FOOTER **
 ** ./src/components/Modules/FormOptions/FormOptions.js
 **/